var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"light":_vm.isDarkModeEnabled,"fab":"","height":"35","width":"35"}},[_c('v-icon',{attrs:{"data-product":_vm.pathName},on:{"click":_vm.navigateBack}},[_vm._v(" "+_vm._s(_vm.mdiArrowLeft)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }